module.exports = __webpack_public_path__ + "img/splash-image-2.38badce8.png";